<template>
<div class="chapter">
<div class="inner_page">
<p class="OT" id="abb"><a id="page_xxiii"></a><a href="#/xhtml/contents#abb">Abbreviations</a></p>
<table cellpadding="0" cellspacing="0" class="abbre">
<tbody><tr>
<td class="tdleft2">AETH</td>
<td class="tdleft2">Asociación para la Educación Teológica Hispana</td>
</tr>
<tr>
<td class="tdleft2">AG</td>
<td class="tdleft2">Assemblies of God</td>
</tr>
<tr>
<td class="tdleft2">AHET</td>
<td class="tdleft2">Asociación Hispana para la Educación Teológica</td>
</tr>
<tr>
<td class="tdleft2">AIC</td>
<td class="tdleft2">Asamblea de Iglesias Cristianas</td>
</tr>
<tr>
<td class="tdleft2">AMEN</td>
<td class="tdleft2">Alianza Ministerial Evangélica National</td>
</tr>
<tr>
<td class="tdleft2">APHILA</td>
<td class="tdleft2">Academia para la Historia de la Iglesia Latinoamericana</td>
</tr>
<tr>
<td class="tdleft2">ARIS</td>
<td class="tdleft2">American Religious Identification Survey</td>
</tr>
<tr>
<td class="tdleft2">ATH</td>
<td class="tdleft2">Asociación Teológica Hispana</td>
</tr>
<tr>
<td class="tdleft2">ATS</td>
<td class="tdleft2">Association of Theological Schools</td>
</tr>
<tr>
<td class="tdleft2">BGCT</td>
<td class="tdleft2">Baptist General Convention of Texas</td>
</tr>
<tr>
<td class="tdleft2">CARA</td>
<td class="tdleft2">Center for Applied Research in the Apostolate</td>
</tr>
<tr>
<td class="tdleft2">CEHILA</td>
<td class="tdleft2">Comisión para el Estudio de La Historia de las Iglesias en América Latina y el Caribe</td>
</tr>
<tr>
<td class="tdleft2">CIA</td>
<td class="tdleft2">Central Intelligence Agency</td>
</tr>
<tr>
<td class="tdleft2">CLADIC</td>
<td class="tdleft2">Concilio Latinoamericano de Iglesias Cristianas</td>
</tr>
<tr>
<td class="tdleft2">CLANY</td>
<td class="tdleft2">Concilio Latinoamericano de la Iglesia de Dios Pentecostal de Nueva York</td>
</tr>
<tr>
<td class="tdleft2">CLUE</td>
<td class="tdleft2">Clergy and Laity United for Economic Justice</td>
</tr>
<tr>
<td class="tdleft2">COGIC</td>
<td class="tdleft2">Church of God in Christ</td>
</tr>
<tr>
<td class="tdleft2">CSO</td>
<td class="tdleft2">Community Service Organization</td>
</tr>
<tr>
<td class="tdleft2">GSS</td>
<td class="tdleft2">General Social Surveys</td>
</tr>
<tr>
<td class="tdleft2">HABBM</td>
<td class="tdleft2">Hispanic Association for Bilingual-Bicultural Ministries</td>
</tr>
<tr>
<td class="tdleft2">HBCT</td>
<td class="tdleft2">Hispanic Baptist Convention of Texas</td>
</tr>
<tr>
<td class="tdleft2">HCAPL</td>
<td class="tdleft2">Hispanic Churches in American Public Life</td>
</tr>
<tr>
<td class="tdleft2"><a id="page_xxiv">HMC</a></td>
<td class="tdleft2">Home Missions Council</td>
</tr>
<tr>
<td class="tdleft2">HSP</td>
<td class="tdleft2">Hispanic Summer Program</td>
</tr>
<tr>
<td class="tdleft2">HTI(C)</td>
<td class="tdleft2">Hispanic Theological Initiative (Consortium)</td>
</tr>
<tr>
<td class="tdleft2">LABI</td>
<td class="tdleft2">Latin American Bible Institute</td>
</tr>
<tr>
<td class="tdleft2">LCMS</td>
<td class="tdleft2">Lutheran Church–Missouri Synod</td>
</tr>
<tr>
<td class="tdleft2">LPAC</td>
<td class="tdleft2">Latino Pastoral Action Center</td>
</tr>
<tr>
<td class="tdleft2">MAP</td>
<td class="tdleft2">Mexican American Program</td>
</tr>
<tr>
<td class="tdleft2">MARCHA</td>
<td class="tdleft2">Metodistas Representando la Causa de los Hispanos Americanos</td>
</tr>
<tr>
<td class="tdleft2">MB</td>
<td class="tdleft2">Mennonite Brethren</td>
</tr>
<tr>
<td class="tdleft2">MEC</td>
<td class="tdleft2">Methodist Episcopal Church</td>
</tr>
<tr>
<td class="tdleft2">MECS</td>
<td class="tdleft2">Methodist Episcopal Church, South</td>
</tr>
<tr>
<td class="tdleft2">MI</td>
<td class="tdleft2">Iglesia de Dios Pentecostal, Movimiento Internacional</td>
</tr>
<tr>
<td class="tdleft2">NAE</td>
<td class="tdleft2">National Association of Evangelicals</td>
</tr>
<tr>
<td class="tdleft2">NAFTA</td>
<td class="tdleft2">North American Free Trade Agreement</td>
</tr>
<tr>
<td class="tdleft2">NaLEC</td>
<td class="tdleft2">National Latino Evangelical Coalition</td>
</tr>
<tr>
<td class="tdleft2">NCC</td>
<td class="tdleft2">National Council of Churches</td>
</tr>
<tr>
<td class="tdleft2">NHCLC</td>
<td class="tdleft2">National Hispanic Christian Leadership Conference</td>
</tr>
<tr>
<td class="tdleft2">PARAL</td>
<td class="tdleft2">Program for the Analysis of Religion among Latinos</td>
</tr>
<tr>
<td class="tdleft2">PCUS</td>
<td class="tdleft2">Presbyterian Church, US</td>
</tr>
<tr>
<td class="tdleft2">PCUSA</td>
<td class="tdleft2">Presbyterian Church (USA)</td>
</tr>
<tr>
<td class="tdleft2">PROLADES</td>
<td class="tdleft2">Programa Latinoamericano de Estudios Sociorreligiosos</td>
</tr>
<tr>
<td class="tdleft2">SBC</td>
<td class="tdleft2">Southern Baptist Convention</td>
</tr>
<tr>
<td class="tdleft2">SDA</td>
<td class="tdleft2">Seventh-Day Adventist Church</td>
</tr>
<tr>
<td class="tdleft2">UFW</td>
<td class="tdleft2">United Farm Workers</td>
</tr>
<tr>
<td class="tdleft2">UMC</td>
<td class="tdleft2">United Methodist Church</td>
</tr>
<tr>
<td class="tdleft2">UPC</td>
<td class="tdleft2">United Pentecostal Church</td>
</tr>
</tbody></table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// abbreviations.vue?448feb47